import { Component, OnInit } from '@angular/core';
import { MitterService } from '../services/mitter.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
  providers: [MitterService]
})
export class ChatComponent implements OnInit {
  channelId: String;
  mitter: any;

  constructor(private mitterService: MitterService) {
    this.channelId = "dc2511b5-4697-4999-b693-a5e348483a49";
    this.mitter = mitterService.getMitter();
  }

  ngOnInit() {
  }
}
